<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card class="shadow-none" v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-for="(item,index) in myList" :key="index">
                    <p v-if="item.type=='<p>'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <input v-if="showAns == 0" type = "text" v-bind:style="getStyle(index, index2)" v-model = "el.content" :size = "el.content.length+1">
                                    <span v-if="showAns == 1" type = "text" v-bind:style="getStyle(index, index2)"> {{el.answer}}</span>
                                    <span v-if="showAns == 2" type = "text" v-bind:style="getStyle(index, index2)">{{el.content}}</span>
                                    <v-icon v-if="showAns == 2 && (myCompare(el.content,el.answer))"  v-bind:style="check_ok" >check_circle</v-icon>  
                                    <v-icon v-if="showAns == 2 && (!myCompare(el.content,el.answer))"  v-bind:style="check_error">error</v-icon>  
                                </v-chip>
                                <v-chip v-if="showAns == 2 && (el.content != el.answer)">
                                    <span type = "text" v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip>
                            </span>
                        </span>
                    </p>       
                    <div id = "mycode" v-if="item.type=='<pre'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <input v-if="showAns == 0" type = "text" v-bind:style="getStyle(index, index2)" v-model = "el.content" :size = "el.content.length+1">
                                    <span v-if="showAns == 1" type = "text" v-bind:style="getStyle(index, index2)"> {{el.answer}}</span>
                                    <span v-if="showAns == 2" type = "text" v-bind:style="getStyle(index, index2)">{{el.content}}</span>
                                    <v-icon v-if="showAns == 2 && (myCompare(el.content,el.answer))"  v-bind:style="check_ok" >check_circle</v-icon>  
                                    <v-icon v-if="showAns == 2 && (!myCompare(el.content,el.answer))"  v-bind:style="check_error">error</v-icon>  
                                </v-chip>
                                <v-chip v-if="showAns == 2 && (el.content != el.answer)">
                                    <span type = "text" v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip>
                            </span>
                        </span>
                    </div>                
                </div>
            </div>

        </v-card>

        <v-card class="shadow-none" v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// nimport { closeSync } from 'fs';

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                fullContent: null,
                showAns: 0, // 0 - user content, 1 - correct content, 2 - check
                myList: [
                    {
                        type: 'p', // p, li
                        list: [
                            {
                                type: 'a', // a, c
                                content : '',
                                answer: '' // correct answer
                            }
                        ]

                    }
                ],
                ignoreSpaces : false,
                aqSome : false,
                check_ok : {
                    color: "green"                    
                },
                check_error : {
                    color: "red"
                },
                correct_answer : {
                    "text-align":"center"
                }

        }
    },
    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        setBR(line) {
            var start = 0
            while (line.indexOf('\n') > -1) {
                start = line.indexOf('\n')
                if ((start > 0 ) && (start-1, start) != '§') {
                    line = line.substring(0,start) + '<br/>' + line.substring(start+1)
                }
            }
            return line
        },
        parseData(tag,endTag) {
            var mList = []
  
            var start = this.fullContent.indexOf(tag);
            var start2 = 0
            // tili >
            if (tag == '<p>') {
                start2 = start + 2
            } else {
                start2 =  this.fullContent.indexOf('>',start);
            }

            var end = this.fullContent.indexOf(endTag)
            if (start > 0) {
                // content to tag
                mList.push( 
                    {
                      type: 'c',
                      content: this.fullContent.substring(0,start),
                      answer: ''
                    }
                )
            }
            var line = this.fullContent.substring(start2 + 1 , end)
            // change \n to br
            if (tag=='<pre') {
                line = this.setBR(line)
                // spaces at the begin of line
                var spaces = '';
                while (line.indexOf(' ') == 0) {
                    spaces = spaces + '&nbsp;'
                    line = line.substring(1)
                }
                line = spaces + line
                // to last line
                while (line.indexOf('<br/> ') > -1) {
                    start = line.indexOf('<br/> ')
                    line = line.substring(0,start) + '<br/>&nbsp;' + line.substring(start+6)
                }
                while (line.indexOf('&nbsp; ') > -1) {
                    start = line.indexOf('&nbsp; ')
                    line = line.substring(0,start) + '&nbsp;&nbsp;' + line.substring(start+7)
                }
            }
            this.fullContent = this.fullContent.substring(end + endTag.length)

            while (line.indexOf('§§') > -1) {
                start = line.indexOf('§§')
                if (start > 0) {
                    mList.push( 
                        {
                        type: 'c',
                        content: line.substring(0,start),
                        answer: ''
                        }
                    )
                }
                end = line.indexOf('§§',start+1)
                mList.push( 
                    {
                        type: 'a',
                        content: '',
                        answer: this.makeNice(line.substring(start+2, end))
                    }
                )                

                line = line.substring(end + 2)
                
            }

            // if it is finished by </tag>
            if (line.indexOf(endTag) > 0) {
                line = line.substring(0,line.indexOf(endTag))                    
            }

            if (line.length > 0) {                
                mList.push( 
                    {
                    type: 'c',
                    content: line,
                    answer: ''
                    }
                )
            } 

            this.myList.push( {
                type: tag,
                list: mList
            })

        },
        unSpan(txt) {
            var data = txt
            var start = 0
            var end = 0
            while (data.indexOf('<span') > -1) {
                start = data.indexOf('<span')
                end = data.indexOf('>',start)
                data = data.substring(0,start) + data.substring(end+1)
                start = data.indexOf('</span>')
                data = data.substring(0,start) + data.substring(start+7)
                
            }
            return data
        },
        initData() {
            this.needInit = false         
            this.showAns = 0
            this.$store.commit('setFeedback', null)   
            this.myContent = JSON.parse(this.dcontent.data.content)            
            var globals = this.dcontent.data.globals
            if (globals.length > 0) {
                globals = JSON.parse(globals)
                this.ignoreSpaces = globals.ignoreSpaces
                this.aqSome = globals.aqSome
            } else {
                this.ignoreSpaces = true
                this.aqSome = false
            }

            this.myList = []
            this.fullContent = this.unSpan(this.myContent.content)            

            while (this.fullContent.indexOf('<p>') > -1 || this.fullContent.indexOf('<pre') > -1 ) { 
                if ((this.fullContent.indexOf('<pre') >-1)  && (this.fullContent.indexOf('<p>') >-1)) {
                       if (this.fullContent.indexOf('<pre') > this.fullContent.indexOf('<p>')) {
                         this.parseData('<p>','</p>')       
                       } else {
                         this.parseData('<pre','</pre>')
                       }
                } else {
                    if (this.fullContent.indexOf('<pre') > -1) {
                         this.parseData('<pre','</pre>')   
                    } else {
                        this.parseData('<p>','</p>')      
                    }    
                }
            }      
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.showAns = 2
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            this.showAns = 1
        },
        getStyle(index, index2) {
            if (this.showAns == 0) return { "color":"black",
                                            "text-align":"center"}            
            if (this.showAns == 1) return { 
                                            "text-align":"center"}

            if (this.showAns == 2 && !(this.myCompare(this.myList[index].list[index2].content,this.myList[index].list[index2].answer))) 
                                            return { "background-color":"red",
                                                    "text-align":"center"}
            if (this.showAns == 2 && (this.myCompare(this.myList[index].list[index2].content,this.myList[index].list[index2].answer))) 
                                            return { 
                                                    "text-align":"center"}
        },
        myCompare(a,b) {
            if (a == b) return true
            if (this.ignoreSpaces) {
                a = a.replace(/\s/g, '')
                b = b.replace(/\s/g, '')
                if (a == b) return true
            }                
            if (this.aqSome) {
                while (a.indexOf('"') > -1) a = a.replace('"','\'')
                while (b.indexOf('"') > -1) b = b.replace('"','\'')
            }
            if (a == b) return true
            return false
        },
        makeNice(a) {
            while (a.indexOf('&lt;')>-1) a = a.replace('&lt;','<')
            while (a.indexOf('&gt;')>-1) a = a.replace('&gt;','>')
            while (a.indexOf('&amp;')>-1) a = a.replace('&amp;','&')
            return a
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        },
        resetEvaluatedData() {
  //          this.showFeedback = false
            this.styleObject.color = 'black'
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
#mycode {
	width: 100%;
	padding: 5px;
	margin: 10px;
	overflow: auto;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 18px;
    font-weight: bold;
	background: #998f8f77;
	border: 1px solid #777;
    font-family:'Courier New', Courier, monospace; 
}
</style>